import React from 'react';

import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import css from './HowToRotatePage.module.css';
import HowToShop from './images/How-to-buy.png';
import HowToSell from './images/How-to-sell.png';
import Criteria from './images/Listing-criteria.jpg';

const HowToRotatePage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HowToRotatePage',
        description: 'About Rotate',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.root}>
          <div className={css.sectionBuyWrapper}>
            <div className={css.sectionLeft}>
              <img src={HowToShop} className={css.howToShop} />
              <div>
                <NamedLink name="SearchPage" className={css.heroButton}>
                  SHOP
                </NamedLink>
              </div>
            </div>
            <div className={css.sectionRight}>
              <h2 className={css.sectionTitle}>How to buy</h2>
              <ol>
                <li>Explore our curated selection of brands <br /> and vintage furniture and interiors</li>
                <li>Discover using the search bar or filters</li>
                <li>
                  Purchase and exchange
                  <ul>
                    <li>
                      Make purchase via one of our approved <br /> payment methods through{' '}
                      <a href="https://stripe.com">Stripe</a>
                    </li>
                    <li>Connect with seller to arrange delivery through your Rotate Room</li>
                  </ul>
                </li>
                <li>Rate your experience and leave a review</li>
                <li>Continue the ROTATION</li>
              </ol>
              <NamedLink name="SearchPage" className={css.heroButton}>
                SHOP
              </NamedLink>
            </div>
          </div>

          <div className={css.sectionSellWrapper}>
            <div className={css.sectionLeft}>
              <h2 className={css.sectionTitle}>How to sell</h2>
              <ol>
                <li>
                  Register and start your
                  {' '}
                  <NamedLink name="ManageListingsPage" className={css.link}>
                    ROTATE ROOM
                  </NamedLink>
                  {'.'}
                </li>
                <li>
                  Create your item listing
                  <ul>
                    <li>Select the brand or list as vintage</li>
                    <li>Choose the category</li>
                    <li>Write a clear title and detailed description</li>
                    <li>
                      Choose a sale price
                    </li>
                    <li>
                      Include shipping costs or pick-up option
                    </li>
                    <li>Upload quality photos or a video that show a true representation</li>
                  </ul>
                </li>

                <li>
                  Wait to sell
                  <ul>
                    <li>
                      Vintage items require approval — see our criteria <a href="#criterias">here</a>
                    </li>
                    <li>
                      If your item brand is not listed, select &lsquo;other brand&rsquo;. This
                      selection requires approval — see our criteria <a href="#criterias">here</a>
                    </li>
                    <li>
                      Manage your items for sale via your{' '}
                      <NamedLink name="ManageListingsPage" className={css.link}>
                        ROTATE ROOM
                      </NamedLink>
                      {' '}account page
                    </li>
                  </ul>
                </li>

                <li>
                  Payment and delivery
                  <ul>
                    <li>
                      Now it is over to you! Ensure any items needing to be shipped are packed well,
                      using old newspapers, towels, tissue paper and sent as soon as possible after you
                      have received payment
                    </li>
                    <li>
                      If you are organising a third party to transport the item, make sure you have
                      booked them and contacted the buyer. Communication is key
                    </li>
                  </ul>
                </li>
                <li>Continue the ROTATION</li>
              </ol>
              <NamedLink name="NewListingPage" className={css.heroButton}>
                SELL
              </NamedLink>
            </div>
            <div className={css.sectionRight}>
              <div className={css.imageWithButton}>
                <img src={HowToSell} className={css.howToSell} />
                <NamedLink name="NewListingPage" className={css.heroButton}>
                  SELL
                </NamedLink>
              </div>
            </div>
          </div>

          <section className={css.sectionCriterias} id="criterias">
            <div className={css.sectionLeft}>
              <img src={Criteria} className={css.criteria} />
            </div>
            <div className={css.sectionRight}>
              <h2 className={css.sectionTitle}>Listing criteria</h2>
              <ol style={{ marginTop: 0, marginBottom: 0 }}>
                <li>
                  <p>
                    Listing a brand
                  </p>

                  <ul>
                    <li>
                      If you are listing an item from one of our approved brands, you are ready to
                      ROTATE
                    </li>
                    <li>
                      If your item brand is not listed, select &lsquo;other brand&rsquo; for
                      approval. The ROTATE HQ team will then assess the brand for relevance and
                      suitability
                    </li>
                  </ul>
                </li>

                <li>
                  <p>If your item is vintage, there is an approval process involved.</p>
                  <ul>
                    <li>
                      Vintage should be revered for years to come. To ROTATE a vintage item it must
                      meet our standards for quality and condition
                    </li>
                    <li>
                      ROTATE HQ will assess and review every submission to ensure the item
                      meets our standards.{' '}
                    </li>
                    <li>
                      Items listed for approval will be accepted based on what we believe those
                      ROTATING will value
                    </li>
                  </ul>
                </li>

                <li>
                  <p>
                    Please provide as much information as possible about your item during the
                    submission process:
                    <ul>
                      <li>Originality</li>
                      <li>Condition</li>
                      <li>Quality</li>
                      <li>Material</li>
                      <li>Era</li>
                      <li>Rarity</li>
                      <li>Style</li>
                    </ul>
                  </p>
                </li>
              </ol>
              <p className={css.tosLink}>
                Visit our{' '}
                <NamedLink name="TermsOfServicePage" className={css.link}>
                  T&Cs
                </NamedLink>{' '}
                for more detail.
              </p>
            </div>
          </section>

        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage >
  );
};

export default HowToRotatePage;
